// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroBlok_root__FPVj0","isTop":"IntroBlok_isTop__zxh_Z"};